/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { ILabelSchema } from './LabelSchema';
import type { IPromoPopupSchema } from './PromoPopupSchema';
import type { IPromoPropSchema } from '../promo_search_result/PromoPropSchema';

export interface IPromoDesktopSchema {
  /** Метки **/
  labels: ILabelSchema[];
  /** IDs ЖК **/
  newbuildingIds: number[];
  /** Название акции **/
  promoName: string;
  /** Попап акции **/
  promoPopup: IPromoPopupSchema;
  /** Пары (заголовок, значение) для свойств акции (Ставка, сумма кредита и т.д.) **/
  promoProps: IPromoPropSchema[];
  /** Тип акции **/
  promoType: EPromoType;
  providerId?: TPromoDesktopSchema_ProviderId;
  /** Лого банка или застройщика **/
  providerLogo: string;
  /** Название автора акции (банка, застройщика и др) **/
  providerName: string;
  /** id акции на стороне провайдера(может повторяться) **/
  providerPromoId: number;
  /** Уникальный id акции (состоит из полей: bank_id, builder_id, provider_promo_id, promo_type) **/
  uniquePromoId: string;
}

export enum EPromoType {
  /** Бонусы **/
  'Bonus' = 'bonus',
  /** Циан ипотека **/
  'CianMortgage' = 'cianMortgage',
  /** Скидки **/
  'Discount' = 'discount',
  /** Рассрочка **/
  'Installment' = 'installment',
  /** Материнский капитал **/
  'MaternalCapital' = 'maternalCapital',
  /** Военная ипотека **/
  'Military' = 'military',
  /** Ипотека **/
  'Mortgage' = 'mortgage',
}
export type TPromoDesktopSchema_ProviderId = number | null;
